import React, { FC, ReactNode } from "react";

import { BaseComponentProps } from "@keepeek/refront-components";
import clsx from "clsx";

export type MediaDetailLayoutProps = {
  children: ReactNode;
} & BaseComponentProps;

const MediaDetailLayout: FC<React.PropsWithChildren<MediaDetailLayoutProps>> = function ({
  children,
  className,
}) {
  return <div className={clsx("MediaDetailLayout", className)}>{children}</div>;
};

export default MediaDetailLayout;
